"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFindOptionsFromDTO = void 0;
function extractFindOptionsFromDTO(dto) {
    const { pageNumber, itemsPerPage, orderBy, ascending, ...rest } = dto;
    return [
        rest,
        {
            orderBy: {
                [orderBy]: ascending ? 'ASC' : 'DESC',
            },
            limit: itemsPerPage,
            offset: (pageNumber - 1) * itemsPerPage,
        },
    ];
}
exports.extractFindOptionsFromDTO = extractFindOptionsFromDTO;
//# sourceMappingURL=dto.js.map